import { createApiConstants } from '@saucelabs/sl-util-redux';

const NAMESPACE = 'health-check';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const HEALTH_CHECK_ENCORE = createApiNamespacedConstants('HEALTH_CHECK_ENCORE');
export const HEALTH_CHECK_RESTO = createApiNamespacedConstants('HEALTH_CHECK_RESTO');
export const HEALTH_CHECK_USERSERVICE = createApiNamespacedConstants('HEALTH_CHECK_USERSERVICE');
